/* ------------------------------------------------
** 主Menu
--------------------------------------------------*/
import { scrollStorage } from "../_js/_helpers/_scrollStorage.js";
$(function () {
    // 配置项
    var config = {
        animationSpeed: 300, // 动画持续时间
        responsiveThreshold: 992 // 响应式阈值，窗口宽度大于此值时才启用 hover 效果
    };

    // 当前窗口宽度
    var winwidth = $(window).width();

    // 动态更新窗口宽度
    $(window).on("resize", function () {
        winwidth = $(window).width();
    });
    // 需要特殊显示的内容


    // 防抖处理：避免快速移动鼠标触发多次 hover
    let hoverTimer;

    // 主菜单 hover 逻辑
    $(".main-menu > ul > li").hover(
        function () {
            clearTimeout(hoverTimer); // 清除离开时的延迟
            // 特殊显示的序号

            // PC版时
            if (winwidth > config.responsiveThreshold) {
                // 检查是否有特殊显示的子菜单
                var spMenu = $(this).data("submenu");
                console.log(`有特殊显示的子菜单`, spMenu);
                var subMenu = $(this).children(".sub"); // 缓存子菜单选择器
                hoverTimer = setTimeout(() => {
                    // 如果不存在特殊显示的子菜单，则显示当前菜单的子菜单
                    if(!spMenu){
                        if (!subMenu.is(":visible")) {
                            $(".mainmenu-spsub").stop(true, true).slideUp(config.animationSpeed); // 隐藏所有特殊显示的子菜单
                            subMenu.stop(true, true).slideDown(config.animationSpeed).parent().siblings().children(".sub").slideUp(config.animationSpeed); // 显示子菜单
                        }
                    }
                    // 如果存在特殊显示的子菜单，则显示特殊显示的子菜单
                    else{
                        if (!$(`.${spMenu}`).is(":visible")) {
                            $(".mainmenu-spsub").stop(true, true).slideUp(config.animationSpeed); // 隐藏所有特殊显示的子菜单
                            subMenu.stop(true, true).slideUp(config.animationSpeed).parent().siblings().children(".sub").slideUp(config.animationSpeed); // 显示子菜单
                            $(`.${spMenu}`).stop(true, true).slideDown(config.animationSpeed); // 显示特殊显示的子菜单
                        }
                    }
                }, 100); // 延迟 100ms
            }
        },
        function () {
            clearTimeout(hoverTimer); // 清除进入时的延迟
            // 手机版时
            if (winwidth > config.responsiveThreshold) {
                var subMenu = $(this).children(".sub"); // 缓存子菜单选择器
                hoverTimer = setTimeout(() => {
                    subMenu.stop(true, true).slideUp(config.animationSpeed); // 隐藏子菜单
                }, 100); // 延迟 100ms
            }
        }
    );

    // 手机版点击togglemenu触发事件
    $(".toggle-menu").click(function () {
        $(".main-menu").toggleClass("active");
        $(".toggle-menu").toggleClass("active");
    });

    // 手机版点击右侧图标展开事件
    $(".main-menu>ul>li>.down").click(function (e) {
        var winwidth = $(window).width();
        if (winwidth < config.responsiveThreshold) {
            $(this).siblings(".sub").slideToggle().parent().toggleClass("open").siblings().removeClass("open").children(".sub").slideUp();
            e.preventDefault();
            return false;
        }
    });

    // 解决当链接存在平滑滚动时在当前页面menu不能上滑的问题
    $(".main-menu a").click(function () {
        if (winwidth > config.responsiveThreshold) {
            console.log(`处理PC时的上滑问题`);
            $(".main-menu .sub").slideUp();
        }
        else {
            console.log(`处理手机版的上滑问题`);
            $(".main-menu").removeClass("active");
            $(".toggle-menu").removeClass("active");
        }
    });

    // 针对附加菜单点击后收回主菜单
    $(".mainmenu-spsub a").click(function(){
        $(".mainmenu-spsub").slideUp();
    })

    // 监听滚动事件
    $(window).on('scroll', function() {
        // 页面滚动距离
        //console.log(`页面距离顶部的距离`,scrollStorage.scrollTopDistance)
        //console.log(`滚动方向`,scrollStorage.pageDirection)
        if(Math.abs(scrollStorage.scrollTopDistance) > 100 && window.innerWidth > 768){
            if(scrollStorage.pageDirection == 'down'){
                //console.log(`向下滚动`)
                $(".mainmenu-spsub").hide();
                $(".un-product-header").slideUp(500);
            }else{
                //console.log(`向上滚动`)
                $(".un-product-header").slideDown(500);
                //$(".product-submenu").slideDown(500);
            }
        }
    });

    // 监听手机版子菜单逻辑
    // 点击产品子菜单逻辑
    $(".product-wap .cat").click(function(){
        $(this).siblings(".loop-block").slideDown().parent().addClass("active").siblings().removeClass("active").children(".loop-block").slideUp();
    })
})